import AllPostsPage from "./AllPostsPage";

export const AllPostsPageConfig = {
  routes: [
    {
      path: "/pages/posts",
      exact: true,
      component: AllPostsPage
    }
  ]
};
